
import store from "../../store/index.js";


/*--------------- Title、 keyworlds、 descriptionText相关 start ↓ ---------------------*/

// 首页Title、 keyworlds、 descriptionText
const homeTitlt = "瑞杰创新科技致力于无人机、机器人、智能设备配件的引领者";
const homeKeywords =
  "GPS定位模组|TOF光流模组|BMS电池管理系统|激光模组|扫地机|电调|无刷电机驱动|360激光雷达|车调|无人机|无人清洁解决方案";
const homeDescription = "欢迎大家来到瑞杰官网";

const homeTitlt_en = "Ruijie Innovation Technology is committed to being a leader in drones, robots, and intelligent device accessories";

const homeKeywords_en = "GPS positioning module | TOF optical flow module | BMS Battery management system | laser module | sweeper | electric tuning | brushless motor drive | 360 laser radar | vehicle tuning | unmanned aerial vehicle | unmanned cleaning solution";

const homeDescription_en = "Welcome everyone to Ruijie's official website"

const baiduToken = {
  "@context": "https://ziyuan.baidu.com/contexts/cambrian.jsonId",
  "@Id": "https://www.yangziclean.com/",
  appid: "",
  title: homeTitlt,
  images: [
    "https://www.yangziclean.com/public/upload/logo/2020/03-17/42138198d3bb61cba80ac3d0d5bcab24.png"
  ],
  description: homeDescription,
  pubDate: "2020-08-24T11:48:01",
  upDate: "2020-08-24T11:48:01",
  lrDate: "2020-08-24T11:48:01"
};

// 当前页面Title
let $titleText = homeTitlt;

// 当前页面keyWords
let $keywordsText = homeKeywords;

// 当前页面descriptionText
let $descriptionText = homeDescription;

// 初始化页面TDK
export function initializationTDK() {
  // setTitle(homeTitlt);
  setKeywords(homeKeywords);
  setDescription(homeDescription);
}

// 设置当前页面Titlt
export function setTitle(titleT) {
  const langType = store.state.lang.langType
  $titleText = langType == "en" ? homeTitlt_en : homeTitlt
  if (titleT) {
    document.title = titleT + "-" + $titleText;
  } else {
    document.title = $titleText;
  }
}

// 设置当前页面keywords
function setKeywords(keywordsT) {
  $keywordsText = keywordsT;
  let head = document.head;
  let keywordsEle = document.createElement("meta");
  keywordsEle.setAttribute("name", "keywords");
  keywordsEle.setAttribute("content", $keywordsText);
  head.appendChild(keywordsEle);
}

// 设置当前页面description
function setDescription(descriptionT) {
  $descriptionText = descriptionT;
  let head = document.head;
  let descriptionEle = document.createElement("meta");
  descriptionEle.setAttribute("name", "description");
  descriptionEle.setAttribute("content", $descriptionText);
  head.appendChild(descriptionEle);
}

// 获取当前页面TDK
function getTDK() {
  return {
    title: $titleText,
    keywords: $keywordsText,
    description: $descriptionText
  };
}

/*--------------- Title、 keyworlds、 descriptionText相关 end ↑ ---------------------*/



// WEBPACK FOOTER //
// ./src/util/thirdPartyAdapter/baiduPromotion.js